import React, { forwardRef, useImperativeHandle } from 'react';
import { Table } from '@ajaibid/components';

import OrderActionProvider from '../components/OrderActionProvider';
import Detail from './components/Detail';
import useColumns from './hooks/useColumns';
import useOrderMt from './hooks/useOrderMt';
import { styTable, styWrapper } from './style';

/**
 * @typedef {import('@services/api/stock/order/margin').OrderMt}  OrderMt
 */

/**
 * @type {import('@ajaibid/components').TableProps<OrderMt>['getRowId']}
 */
function getRowId(row, ix, parent) {
  return `${parent ? `${parent?.id}__` : ''}${row?.order_no || ix}`; // Real one
}

function renderRowExpand(row) {
  return <Detail item={row.original} />;
}

const StockOrderMT = forwardRef((_, ref) => {
  const { data, isInitialLoading, refetch, isRefetching, fetchNextPage, isFetchingNextPage } =
    useOrderMt();

  const columns = useColumns();

  useImperativeHandle(ref, () => ({
    // Allow the following functions & variables to be called from its parents
    refetchTable: refetch,
    isRefetching: isRefetching,
  }));

  return (
    <OrderActionProvider>
      <div className={styWrapper}>
        <Table
          className={styTable}
          data={data}
          columns={columns}
          options={{ isHeaderVisible: true, isRowExpandable: true }}
          fetchNext={fetchNextPage}
          getRowId={getRowId}
          isInitialLoading={isInitialLoading}
          isFetchingNext={isFetchingNextPage}
          renderRowExpand={renderRowExpand}
          emptyStateContent="Mulai bertransaksi dan lihat statusnya di sini."
        />
      </div>
    </OrderActionProvider>
  );
});

export default StockOrderMT;
